import { api } from '@/apis';
import { isEmpty, log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useVehicleBoundaryPolls({ boundary, query: filter }) {
  const queryKey = ['vehicleBoundaryPolls', boundary, filter];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const { time, ...match } = filter;

      const featureRequestParams = {
        startTime: time.$gte,
        endTime: time.$lt,
        boundary: boundary,
        ...match,
      };

      log('Read', 'Vehicle Boundary Polls', { boundary, query: filter });

      return api
        .post('boundary-polls/vehicles', {
          json: featureRequestParams,
          signal,
        })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60 * 8,
    enabled: !!boundary && !isEmpty(filter),
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
